import {
  FileTextOutlined,
  InfoCircleOutlined,
  ContainerOutlined,
  TagsOutlined,
  CoffeeOutlined,
  ExperimentOutlined,
  InboxOutlined,
  ShopOutlined,
  ShoppingOutlined,
  AppstoreOutlined,
  CloudOutlined,
  BulbOutlined,
  TableOutlined,
  CheckCircleOutlined,
  CustomerServiceOutlined,
  SelectOutlined,
} from '@ant-design/icons';

export const wizardIcons = {
  intro: FileTextOutlined,
  productInformation: InfoCircleOutlined,
  packagingStorage: ContainerOutlined,
  productCount: TagsOutlined,
  foodService: CoffeeOutlined,
  alcoholic: ExperimentOutlined,
  retailInnerPack: InboxOutlined,
  storeDisplay: ShopOutlined,
  merchandisedInTray: ShoppingOutlined,
  multipack: AppstoreOutlined,
  perishable: CloudOutlined,
  recommendation: BulbOutlined,
  recommendTemplate: FileTextOutlined,
  recommendGrid: TableOutlined,
  productGridQuestion: SelectOutlined,
  success: CheckCircleOutlined,
  contactSales: CustomerServiceOutlined,
};
